/**
 * @fileoverview GET handler for the "/companies/:company_id/email_self_serve/:app_group_id/configuration_data" endpoint
 */
import fetch from "@lib/fetch";

import { createGetFetcherFunctionWithShadowError, reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdEmailSelfServeConfigurationData } from "./constants";
import type { GetConfigurationDataResult, GetConfigurationDataError } from "./types";
import { isGetConfigurationDataResult } from "./validators";

export const getConfigurationData = reactQueryFetcherAdapter(
  companiesCompanyIdEmailSelfServeConfigurationData,
  createGetFetcherFunctionWithShadowError<GetConfigurationDataError>()(
    (signal: AbortSignal, companyId: string, appGroupId: string): Promise<GetConfigurationDataResult> => {
      return fetch(
        `/companies/${companyId}/email_self_serve/${appGroupId}/configuration_data`,
        "GET",
        {},
        { signal },
        { propagateFetchRequestError: false }
      );
    }
  ),

  isGetConfigurationDataResult
);
